import { useSyncExternalStore } from 'react';

// Module-scoped flag set by the Payment page once the order/payment intent
// has been created (the "pay" step). The global Header reads it to hide the
// cart button: at that point the basket is locked in and editing it via the
// cart sidebar would desync from the already-created payment intent. On the
// earlier "review" step the cart stays available — the order isn't committed
// yet, so the customer can still edit freely.
let isLocked = false;
const listeners = new Set();

const setLocked = (next) => {
  const value = typeof next === 'function' ? next(isLocked) : next;
  if (value === isLocked) return;
  isLocked = value;
  listeners.forEach((fn) => fn());
};

const subscribe = (cb) => {
  listeners.add(cb);
  return () => listeners.delete(cb);
};

const getSnapshot = () => isLocked;

const useCheckoutLocked = () => {
  const current = useSyncExternalStore(subscribe, getSnapshot);
  return {
    isLocked: current,
    setLocked,
  };
};

export default useCheckoutLocked;
